export default __webpack_public_path__ + "assets/png/fdc0f63fd29fade9c3d018d36729e0bf.png";